<template>
<div class="text-right">
  <v-btn v-shortkey="['f2']" @shortkey="changeFormStatus('pn')" @click="changeFormStatus('pn')" v-if="formStatus === 'view' || formStatus === 'pn'" class="ma-2 white--text" id="btn" tile color="blue lighten-3">
    پاس نقدی(F2)
  </v-btn>
  <v-btn v-shortkey="['f4']" @shortkey="changeFormStatus('dv')" @click="changeFormStatus('dv')" v-if="formStatus === 'view' || formStatus === 'dv'" class="ma-2 white--text" id="btn" tile color="blue lighten-2">
    واگذاری به حساب(F4)
  </v-btn>
  <v-btn v-shortkey="['f6']" @shortkey="changeFormStatus('ph')" @click="changeFormStatus('ph')" v-if="formStatus === 'view' || formStatus === 'ph'" class="ma-2 white--text" id="btn" tile color="blue lighten-1">
    پاس به حساب(F6)
  </v-btn>
  <v-btn v-shortkey="['f7']" @shortkey="changeFormStatus('out')" @click="changeFormStatus('out')" v-if="formStatus === 'view' || formStatus === 'out'" class="ma-2 white--text" id="btn" tile color="blue darken-1">
    خارج کردن از حساب(F7)
  </v-btn>
  <v-btn v-shortkey="['f8']" @shortkey="changeFormStatus('bg')" @click="changeFormStatus('bg')" v-if="formStatus === 'view' || formStatus === 'bg'" class="ma-2 white--text" id="btn" tile color="blue darken-2">
    برگشت زدن(F8)
  </v-btn>
  <v-btn v-shortkey="['f9']" @shortkey="changeFormStatus('odat')" @click="changeFormStatus('odat')" v-if="formStatus === 'view' || formStatus === 'odat'" class="ma-2 white--text" id="btn" tile color="blue darken-3">
    عودت به شخص(F9)
  </v-btn>
  <v-btn v-shortkey="['f10']" @shortkey="changeFormStatus('undo')" @click="changeFormStatus('undo')" v-if="formStatus === 'view' || formStatus === 'undo'" class="ma-2 white--text" id="btn" tile color="blue darken-4">
    بازگشت به وضعیت قبل(F10)
  </v-btn>

</div>
</template>

<script>
export default {
  name: 'ListButtons',
  props: ['formStatus'],
  methods: {
    changeFormStatus(type) {
      this.$emit('childSetFormStatus', type)
    },
  },
}
</script>

<style lang="scss">
#btn {
    font-size: 18px;
}
</style>
